import type AuthorizationService from 'volta/services/authorization';

import Helper from '@ember/component/helper';
import { observer } from '@ember/object';
import { inject as service } from '@ember/service';

export interface CannotStrictSignature {
  Args: {
    Positional: [string, string];
  };
  Return: boolean;
}

export default class CannotStrict extends Helper<CannotStrictSignature> {
  @service authorization!: AuthorizationService;

  // eslint-disable-next-line ember/no-observers
  onPermissionsInit = observer('authorization.permissions', () => {
    this.recompute();
  });
  compute([right, entityType]: [string, string]) {
    return this.authorization.cannotStrict(entityType, right);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'cannot-strict': typeof CannotStrict;
  }
}
